import { FC } from 'react';
import { TitleProps } from 'antd/es/typography/Title';
import { StyledTitle } from './Title.styles';

const Title: FC<TitleProps> = ({ children, ...props }) => <StyledTitle {...props}>{children}</StyledTitle>;

export default Title;
